<template>
    <div class="list">
        <div class="flex__around search-box">
            <div class="flex align-center search__item">
                <span class="fs_28 c_b3 jcicon jcicon-sousuo1">&nbsp;</span>
                <input class="fs_28" type="text" placeholder="请输入关键字搜索" v-model="loads.keyword">
            </div>
        </div>
        <!-- 一行一个 -->
        <div class="row-box">
            <div class="flex row__item" v-for="(item,index) in list" :key="index" v-link="'/Integral/Detail/'+item.id">
                <img :src="item.cover_img" alt="">
                <div class="flex__null__around row__info">
                    <span class="fs_30 c_1a lh_40 ellipsis_two">{{item.name}}</span>
                    <div class="mt_10 lh_40">
                        <span class="fs_36 c_main" v-if="item.integral">{{item.integral}}<span class="fs_24">积分</span></span>
                        <span class="fs_24 c_main" v-if="item.integral&&item.money!='0.00'">+</span>
                        <span class="fs_28 c_main" v-if="item.money!='0.00'">{{item.money}}<span class="fs_24">元</span></span>
                    </div>
                    <span class="fs_24 c_80">&ensp;已兑{{item.sales}}</span>
                </div>
            </div>
        </div>
        <jc-list :url="'/Integral/getProductList'" :loads="loads" @load='getList'></jc-list>
    </div>
</template>
<script>
export default {
    name:'IntegralList',
    data(){
        return{
            list:[],
            loads:{
                category_id: '',
                keyword: '',
                page:1
            }
        }
    },
    methods:{
        getList (data) { 
            this.list=data;
        }
    },
    mounted(){
        if(this.$store.state.integral){
            this.loads.keyword=this.$store.state.integral;
        }
        if(this.$route.params.id){
            this.loads.category_id=this.$route.params.id;
        }
    },
    destroyed(){
        this.$store.commit('setIntegral','');
    }
}
</script>
<style scoped>
    /* 一行一个 */
    .row-box{
        overflow: hidden;
        padding: 0 30px 30px;
        background: #fff;
    }
    .row__item{
        margin-top: 30px;
    }
    .row__item img{
        width: 250px;
        height: 250px;
        border-radius: 10px;
    }
    .row__info{
        margin-left: 30px;
    }
</style>



// WEBPACK FOOTER //
// src/pages/integral/List.vue